// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3NjeV","badges":"styles_badges__1D7Xg"};